"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBadgeWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBadgeWrapper = styled_components_1.default.div `
  border-radius: 4px 0px;
  display: flex;
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  font-size: 0.75rem;
  position: absolute;
  color: ${ui_components_1.baseColors.white};
  font-weight: 500;
  line-height: 1;
  background: ${ui_components_1.baseColors.maroon};
  top: -1px;
  left: -1px;
  z-index: 1;

  &.updated {
    background: ${ui_components_1.baseColors.blue300};
  }
`;
